import { render, staticRenderFns } from "./PurchTable.vue?vue&type=template&id=5f722224&scoped=true"
import script from "./PurchTable.vue?vue&type=script&lang=js"
export * from "./PurchTable.vue?vue&type=script&lang=js"
import style0 from "./PurchTable.vue?vue&type=style&index=0&id=5f722224&prod&lang=scss&scoped=true"
import style1 from "./PurchTable.vue?vue&type=style&index=1&id=5f722224&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f722224",
  null
  
)

export default component.exports